import { initializeLanguage } from '@screenleads/i18n';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { appConfig } from './app/app.config';
import './app/chart.config'; // Initialize Chart.js configuration

bootstrapApplication(AppComponent, appConfig);

initializeLanguage();
